import { FC } from 'react';
import { Link } from 'atoms/Link/Link';
import { useTranslations } from 'modules/i18n/useTranslations';
import { FactFinderSuggestions } from 'commerce/factFinder/types';
import { ResultTitle } from '../ResultTitle';
import styles from './styles.module.css';

export const SuggestedKeywords: FC<{
  keywords?: FactFinderSuggestions[];
  triggerSuggestionEvent?: () => void;
  isSmall?: boolean;
}> = ({ keywords, triggerSuggestionEvent }) => {
  const t = useTranslations();

  return (
    <div>
      <ResultTitle title={t('search.titles.suggested-keywords')} />
      {keywords?.map(({ name, attributes }) => {
        return (
          <Link
            key={name}
            href={attributes.Url || ''}
            className={styles.keyword}
            // Set correct parameters for GTM event
            onClick={triggerSuggestionEvent}
          >
            {name}
          </Link>
        );
      })}
    </div>
  );
};
